import { RiseOutlined, FallOutlined } from "@ant-design/icons";
import IconItem from "modules/common/icon/IconItem";
import React, { useEffect } from "react";
import { Card, Col, Row } from "react-bootstrap";
import corner1 from "assets/img/illustrations/corner-2.png";
import Background from "modules/common/Background";
import { useAgentCall } from "./store/store";
const colorPicker = [
  "warning",
  "info",
  "success",
  "danger",
  "primary",
  "secondary",
  "warning",
];

function AgentPerformance() {

  const {agentCallData, fetchAgentCall} = useAgentCall();

  useEffect(()=>{
    fetchAgentCall();
  },[])

  const convertTimeToSeconds = (timeString) => {
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  };

  const convertSecondsToTime = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

  const dataArrayCalculated = (dateArgument) => {
    if (agentCallData?.[dateArgument] && Object.keys(agentCallData[dateArgument])?.length > 0) {
      const dataArray = Object.values(agentCallData[dateArgument]).reduce((acc, entry) => {
        Object.keys(entry)?.forEach((key) => {
          if (key === "total_talk_time") {
            acc[key] = (acc[key] || 0) + convertTimeToSeconds(entry[key]);
          } else {
            acc[key] = (acc[key] || 0) + entry[key];
          }
        });
        return acc;
      }, {});
  
      if (dataArray["total_talk_time"] !== undefined) {
        dataArray["total_talk_time"] = convertSecondsToTime(dataArray["total_talk_time"]);
      }
      return dataArray;
    }
    return {}; 
  };
  
  function combineData(yesterdayData, dayBeforeYesterdayData) {
    return {
        unanswered: {
            yesterday: yesterdayData?.unanswered,
            dayBeforeYesterday: dayBeforeYesterdayData?.unanswered
        },
        total_attempts: {
            yesterday: yesterdayData?.total_attempts,
            dayBeforeYesterday: dayBeforeYesterdayData?.total_attempts
        },
        answered: {
            yesterday: yesterdayData?.answered,
            dayBeforeYesterday: dayBeforeYesterdayData?.answered
        },
        total_talk_time: {
            yesterday: yesterdayData?.total_talk_time,
            dayBeforeYesterday: dayBeforeYesterdayData?.total_talk_time
        },
        unique_attempts: {
            yesterday: yesterdayData?.unique_attempts,
            dayBeforeYesterday: dayBeforeYesterdayData?.unique_attempts
        },
        unique_unanswered_attempts: {
            yesterday: yesterdayData?.unique_unanswered_attempts,
            dayBeforeYesterday: dayBeforeYesterdayData?.unique_unanswered_attempts
        }
    };
}

const yesterdayData = dataArrayCalculated('yesterday');
const dayBeforeYesterdayData = dataArrayCalculated('dayBeforeYesterday');

const combinedData = combineData(yesterdayData, dayBeforeYesterdayData);

  return (
    <div className="mb-3">
      <div className="h-100">
        <div className="" style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap:"1rem" }}>
          {Object.keys(combinedData)?.map((stat, index) => (
            <div key={combinedData[stat].id}>
              <Card className="h-100">
                <Card.Body>
                  <Background
                    image={corner1}
                    style={{
                      borderTopRightRadius: "0.375rem",
                      borderBottomRightRadius: "0.375rem",
                    }}
                  />
                  <Row className="flex-between-center">
                    <Col className="d-lg-block flex-between-center me-n4">
                      <div className="d-flex flex-row align-items-center">
                        <IconItem
                          tag="div"
                          icon="phone"
                          bg={`soft-${colorPicker[index]}`}
                          color={colorPicker[index]}
                          size="lg"
                          iconClass="fs--2"
                          className="me-2 shadow-none"
                        />
                        <h6 className="mb-2 text-900">
                          {stat.replaceAll("_", " ").charAt(0).toUpperCase() +
                            stat.replaceAll("_", " ").slice(1).toLowerCase()}
                        </h6>
                      </div>
                      <div className="d-flex flex-row gap-4 align-items-center">
                      <h4 className="fs-3 ps-5 fw-normal text-700 mb-0">
                        {combinedData[stat]?.yesterday}
                      </h4>
                      <h5 className="text-500">{combinedData[stat]?.dayBeforeYesterday}</h5>
                      </div>
                    </Col>
                    <Col xs="auto" className="h-100">{combinedData[stat]?.yesterday>=combinedData[stat]?.dayBeforeYesterday?<RiseOutlined style={{ fontSize: "24px", color: "#1890ff" }} />:<FallOutlined style={{ fontSize: "24px"}} className="text-danger" />}</Col>
                  </Row>
                </Card.Body>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AgentPerformance;
